import CheckIcon from "../../../assets/svg/check-icon";
import { COMMUNICATION_TYPE_OPTIONS } from "../utils/constants";
import { useState } from "react";
import Button from "../../Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  selectBillingFilters,
  setBillingCommunicationType,
} from "../../../redux/slices/filterSlice";

const BillingCommunicationTypeFilter = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const communicationType = useSelector(
    selectBillingFilters
  )?.communicationType;
  const [selectedOption, setSelectedOption] = useState<{
    value: string;
    displayValue: string;
  }>({
    value: communicationType.value as string,
    displayValue: communicationType.displayValue as string,
  });

  const dispatch = useDispatch();
  const handleSelectOption = (value: string, displayValue: string) => {
    setSelectedOption({ value, displayValue });
  };
  const handleApply = () => {
    if (selectedOption.value === communicationType.value) {
      return;
    }
    dispatch(
      setBillingCommunicationType({
        value: selectedOption.value,
        displayValue: selectedOption.displayValue,
      })
    );
    onClose();
  };
  return (
    <div className="flex flex-col gap-2 mt-2 px-3">
      <h2 className="text-md  text-heading-text dark:text-heading-text-dk py-1.5">
        Select your preferred type of communication.
      </h2>
      {COMMUNICATION_TYPE_OPTIONS.map((option) => (
        <div
          key={option.value}
          onClick={() => handleSelectOption(option.value, option.displayValue)}
          className={`flex items-center justify-between border cursor-pointer ${
            selectedOption.value === option.value
              ? "border-verba-blue dark:border-verba-blue-dk bg-verba-blue-light-card-bg dark:bg-verba-blue-light-card-bg-dk"
              : "border-border-gray dark:border-border-gray-dk"
          } rounded-lg py-[13.5px] px-3`}
        >
          <div>{option.content}</div>
          {selectedOption.value === option.value && (
            <CheckIcon className="w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk" />
          )}
        </div>
      ))}
      <div className="flex justify-end gap-2 mt-4">
        <Button
          innerText="Cancel"
          buttonContainerClass="py-1 px-7.5 border border-verba-indigo dark:border-verba-indigo-dk rounded-lg"
          innerTextClass="text-md font-medium whitespace-nowrap text-heading-text dark:text-heading-text-dk"
          onClick={onClose}
        />
        <Button
          innerText="Apply"
          buttonContainerClass="py-1 px-7.5 rounded-lg bg-verba-indigo dark:bg-verba-indigo-dk"
          innerTextClass="text-md font-medium whitespace-nowrap text-pure-white dark:text-pure-white-dk"
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default BillingCommunicationTypeFilter;

